import * as React from "react";
const SvgFiRrSatellite = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-satellite_svg__a)">
      <path
        fill="#062147"
        d="m19.281 10.669 3.486-3.486a4.21 4.21 0 0 0 0-5.951A4.18 4.18 0 0 0 19.791 0a4.18 4.18 0 0 0-2.975 1.232l-3.46 3.46-2.814-2.814C9.408.743 7.43.746 6.3 1.878L3.921 4.256a3.003 3.003 0 0 0 0 4.243l2.64 2.639a7.88 7.88 0 0 0-5.323.874 2.42 2.42 0 0 0-1.216 1.799c-.107.784.15 1.553.708 2.111l2.965 2.966-1.404 1.404a.999.999 0 1 0 1.414 1.414l1.404-1.404 2.965 2.966a2.48 2.48 0 0 0 2.112.707 2.42 2.42 0 0 0 1.8-1.215 7.9 7.9 0 0 0 .885-5.259l2.65 2.65c.566.566 1.32.878 2.121.878s1.555-.312 2.121-.878l2.38-2.378c.565-.567.878-1.32.878-2.122s-.312-1.555-.879-2.121zm-1.05-8.023c.834-.834 2.288-.833 3.122 0 .86.861.86 2.262 0 3.123l-9.328 9.327a7.85 7.85 0 0 0-3.12-3.123zM5.335 5.671l2.38-2.379a1.024 1.024 0 0 1 1.413 0l2.814 2.814L8.15 9.899 5.335 7.085a1 1 0 0 1 0-1.414m4.908 16.107a.43.43 0 0 1-.328.216.51.51 0 0 1-.426-.141l-7.345-7.345a.5.5 0 0 1-.14-.425.44.44 0 0 1 .216-.329 5.906 5.906 0 0 1 7.054.969 5.91 5.91 0 0 1 .97 7.055m10.484-5.42-2.379 2.379a1.023 1.023 0 0 1-1.414 0l-2.862-2.862 3.793-3.793 2.862 2.862a1 1 0 0 1 .293.707 1 1 0 0 1-.293.707"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-satellite_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSatellite;
